/**
 * Created 03.11.2024
 * Pinia store for system data.
 */

import { defineStore } from 'pinia';
import {
  ref,
} from 'vue';
import {
  BuildingLibraryIcon, BuildingOfficeIcon, CakeIcon, GlobeEuropeAfricaIcon, HomeIcon, MapIcon, MapPinIcon,
} from '@heroicons/vue/24/outline';

export const useSystemStore = defineStore('system', () => {
  /* *********************************************************************
   * Initial state setup
   * ****************************************************************** */

  // Map entity types to plural
  const entityTypesPluralMapping = {
    lodging: 'lodgings',
    eatery: 'eateries',
    activity: 'activities',
    venue: 'venues',
    landmark: 'landmarks',
    other: 'others',
    global: 'globals',
  };

  // map entity types to icons
  const entityTypesIconMapping = {
    lodging: HomeIcon,
    eatery: CakeIcon,
    activity: MapIcon,
    venue: BuildingOfficeIcon,
    landmark: BuildingLibraryIcon,
    other: MapPinIcon,
    global: GlobeEuropeAfricaIcon,
  };

  /* *********************************************************************
   * Set up reactive state
   * ****************************************************************** */

  const printMode = ref(false);
  const allMediaItems = ref([]);

  /* *********************************************************************
   * System data update functions
   * ****************************************************************** */

  /**
   * Function to set print mode
   * @param {boolean} state - Print mode state (true or false)
   */
  function setPrintMode(state) {
    printMode.value = state;
  }

  /**
   * Function to set all media items
   * @param {Array} mediaItems - Array of media items
   */
  function setAllMediaItems(mediaItems) {
    allMediaItems.value = mediaItems;
  }

  return {
    entityTypesPluralMapping,
    entityTypesIconMapping,
    printMode,
    setPrintMode,
    allMediaItems,
    setAllMediaItems,
  };
});
